import React, { useState } from 'react'

import { Button, Stack, Typography } from '@mui/material'
import ExportModal from './ExportModal'
import { SiteViewModel } from '../../ViewModel'
import NewSiteDialog from './NewSiteDialog'
import { useAuth } from '../../Auth'
import NewEventDialog from '../../Event/NewEventDialog'

interface ActionsPanelProps {
  site: SiteViewModel
}

function ActionsPanel({ site }: ActionsPanelProps) {
  const [exportModalOpen, setExportModalOpen] = useState(false)
  const [siteModalOpen, setSiteModalOpen] = useState(false)
  const [eventModalOpen, setEventModalOpen] = useState(false)

  const { isAdmin } = useAuth()

  return (
    <Stack>
      {isAdmin && (
        <>
          <Typography fontWeight="bold">Site</Typography>
          <Button
            variant="contained"
            onClick={() => {
              setSiteModalOpen(true)
            }}
          >
            Update Site Details
          </Button>
          <Button
            variant="contained"
            sx={{ margin: '5px' }}
            onClick={() => {
              setEventModalOpen(true)
            }}
          >
            Add an event
          </Button>
        </>
      )}

      <Typography fontWeight="bold">Export</Typography>
      <Button
        variant="contained"
        onClick={() => {
          setExportModalOpen(true)
        }}
      >
        Export Events
      </Button>
      <ExportModal
        siteId={site.id}
        open={exportModalOpen}
        handleClose={() => {
          setExportModalOpen(false)
        }}
      />

      <NewSiteDialog
        siteId={site.id}
        open={siteModalOpen}
        onClose={() => {
          setSiteModalOpen(false)
        }}
      />

      <NewEventDialog
        siteId={site.id}
        eventId={''}
        open={eventModalOpen}
        onClose={() => {
          setEventModalOpen(false)
        }}
      />
    </Stack>
  )
}

export default ActionsPanel
